var supara_token = "";
var settings = {
  url: "https://api.backend.gw.t.int.suparagroup.com/gq-connect/auth/token",
  method: "POST",
  timeout: 0,
  headers: {
    "Content-Type": "application/json",
  },
  data: JSON.stringify({
    api_key: "98931F7B-B67D-492C-96F1-A50D66C4DA1B",
    client: "magenest",
  }),
};
var test = [];

$.ajax(settings).done(function (response) {
  supara_token = response.data.token;
});

function formatDate(dateString) {
    // Parse the given string into a Date object
    var date = new Date(dateString);
    
    // Format the date using toLocaleDateString() with options
    var options = { day: 'numeric', month: 'short', year: 'numeric' };
    var formattedDate = date.toLocaleDateString('en-US', options);
    
    return formattedDate;
}
function getLastDateOfMonth(year, month) {
  let nextMonth = new Date(year, month, 1);
  let lastDayOfMonth = new Date(nextMonth - 1);
  return lastDayOfMonth.getDate().toString();
}
function getCouponList(phone, month = false, year = false) {
  url =
    "https://api.backend.gw.t.int.suparagroup.com/gq-connect/customers/coupons?mobile=" +
    phone;
  if (month != false) {
    date_from = year + "-" + month + "-01";
    date_to = year + "-" + month + "-" + getLastDateOfMonth(parseInt(year), parseInt(month));
    url = url + "&start_date=" + date_from + "&end_date=" + date_to;
  }
  var ajax_reward = {
    url: url,
    method: "GET",
    timeout: 0,
    headers: {
      Authorization: "Bearer " + supara_token,
    },
  };
  $.ajax(ajax_reward).done(function (response) {
    var coupon_history_list = "";
    for (i = 0; i < response.data.coupons.length; i++) {
        coupon = response.data.coupons[i];
          var expiryDate = new Date(coupon.validTill);
          var currentDate = new Date();
        var state = "REDEEMED";
        if (
          expiryDate <= currentDate &&
          coupon.redemptionsLeft > 0
        ) {
          state = "EXPIRED";
        }
        if (
          expiryDate <= currentDate ||
          coupon.redemptionsLeft < 0
        ) {
          coupon_history_list =
            coupon_history_list +
            '<div class="coupon-history-div"><div class="coupon-img-div"><img class="coupon-img" src="' +
            coupon.imageUrl +
            '"><div class="state-tag">' +
            state +
            '</div></div><div class="coupon-content"><div class="coupon-text">' +
            coupon.description +
            '</div><div class="coupon-date">' +
            "Expired: " +
            formatDate(coupon.validTill) +
            "</div></div></div>";
        }
    }
    document.getElementById("coupon-history-list").innerHTML =
      coupon_history_list;
  });
}
